import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrambleTextPlugin } from './util/ScrambleTextPlugin.min.js';

gsap.registerPlugin(ScrollTrigger, ScrambleTextPlugin);

const init = (isRM) => {
  // stagger content
  const staggerChildren = document.querySelectorAll(
    '.animation-stagger-children'
  );
  if (staggerChildren.length > 0) {
    staggerChildren.forEach((content) => {
      const el = content.children;
      if (el.length < 1) return;

      gsap.from(el, {
        y: !isRM ? 15 : 0,
        autoAlpha: 0,
        stagger: !isRM ? 0.125 : 0,
        scrollTrigger: {
          trigger: content,
          once: true,
          start: !isRM ? 'top 90%' : 'top bottom'
        }
      });
    });
  }

  // simple fades
  const fadeIn = document.querySelectorAll('.animation-fade-in');
  if (fadeIn.length > 0) {
    fadeIn.forEach((el) => {
      gsap.from(el, {
        scale: 0.9,
        autoAlpha: 0,
        scrollTrigger: {
          trigger: el,
          once: true,
          start: 'top 90%'
        }
      });
    });
  }

  // grid fades
  const gridItems = document.querySelectorAll('.animation-grid-item');
  if (gridItems.length > 0) {
    ScrollTrigger.batch(gridItems, {
      onEnter: (batch) =>
        gsap.from(batch, {
          autoAlpha: 0,
          y: !isRM ? 20 : 0,
          stagger: !isRM ? 0.075 : 0
        }),
      once: true
    });
  }

  // steps fade-ins
  const steps = document.querySelectorAll('.animation-steps');
  if (steps.length > 0) {
    gsap.set(steps, { visibility: 'hidden' });
    ScrollTrigger.batch(steps, {
      start: !isRM ? 'top 66.6%' : 'top bottom',
      onEnter: (batch) =>
        gsap.from(batch, {
          autoAlpha: 0,
          y: 25,
          stagger: !isRM ? 0.4 : 0,
          duration: !isRM ? 0.66 : 0.0001
        }),
      once: true
    });
  }

  // rotation scrubs
  const rotations = document.querySelectorAll('.animation-rotation');
  if (rotations.length > 0) {
    rotations.forEach((el) => {
      if (!isRM) {
        gsap.to(el, {
          rotate: 45,
          ease: 'none',
          scrollTrigger: {
            trigger: el,
            scrub: 3,
            start: 'top bottom',
            end: 'bottom top'
          }
        });
      }
    });
  }

  // card parallaxes
  const cards = document.querySelectorAll('.animation-parallax-card');
  if (cards.length > 0) {
    cards.forEach((card) => {
      const yValue = innerWidth > 1239 ? gsap.utils.random(-33.333, -45) : 0;
      const randomY = !isRM ? yValue : 0;
      gsap.from(card, {
        yPercent: randomY,
        ease: 'none',
        scrollTrigger: {
          trigger: card,
          start: 'top bottom',
          end: `bottom-=${randomY}% top`,
          scrub: !isRM ? 1.5 : false
        }
      });
    });
  }

  // angled card parallaxes
  const angledCards = document.querySelectorAll(
    '.animation-parallax-angled-card'
  );
  if (angledCards.length > 0) {
    if (isRM) return;

    angledCards.forEach((card) => {
      const randomY = gsap.utils.random(5, 15);
      const randomSpin = gsap.utils.random(-25, -15);
      gsap.from(card, {
        yPercent: randomY,
        rotate: randomSpin,
        ease: 'none',
        scrollTrigger: {
          trigger: card,
          start: 'top bottom',
          end: `bottom-=${randomY}% top`,
          scrub: 1.5
        }
      });
    });
  }
  // end
};

export { init };
